import type GuiValueDto from "../../../../dto/construction/GuiValueDto";
import {type TableData} from "./ConstructionTableProps";

const hasParentId = (constructionPartItem: TableData): constructionPartItem is TableData & {parentId: string} => {
  return constructionPartItem !== null && "parentId" in constructionPartItem && constructionPartItem.parentId !== null;
};

const hasId = (constructionPartItem: TableData): constructionPartItem is TableData & {id: string} => {
  return constructionPartItem !== null && "id" in constructionPartItem && constructionPartItem.id !== null;
};

const isGuiValueDto = (value: unknown): value is GuiValueDto<unknown> =>
  typeof value === "object" && value !== null && "value" in value;

const hasExtraInfo = (constructionElementsName: string, constructionElementsProperty: string): boolean => 
  constructionElementsName === "devices" && constructionElementsProperty === "type";

export {hasId, hasParentId, isGuiValueDto, hasExtraInfo};
